<template>
	<div id="main" @keyup="watchEvents($event)" @mousemove="watchEvents($event)" :class="{'isloading': appLoading}">
		<transition-group name="fade" mode="out-in">
			<div v-for="(toast, t) in toasts" :key="`toast_${t}`"
				:class="toast.type"
				@click="holdThis(toast)" class="toast">
				<p>{{toast.msg}}</p>
				<font-awesome-icon aria-hidden="true"
				@click="removeThis(toast)"
				:icon="['fas', 'times']" />
			</div>
			<!-- <div v-for="(toast, t) in toasts" :key="`toast_${t}`"
				class="growl-item"
				:class="toast.type"
				@click="holdThis(toast)">
				<button type="button" class="close" aria-hidden="true"
					@click="removeThis(toast)">×</button>
				<div class="time-loader">
					<div class="progress-bar progress-bar-striped active"
						:style="{ width: toast.ttl + '%' }"
					></div>
				</div>
				<div class="top-msg"></div>
				<div class="bottom-msg">{{toast.msg}}</div>
			</div> -->
		</transition-group>
		<div class="sidenav">
			<div class="sidenav-left">
				<!--<router-link tag="div" class="sidenav-item dashboard-icon" :to="{ path: '/pages', name: 'pages'}">-->
					<!--<font-awesome-icon :icon="['fab', 'vuejs']" />-->
				<!--</router-link>-->
				<a :href="this.$store._vm.DOMAIN_URL + '/users/' + this.$store._vm.USER">
					<div class="sidenav-item dashboard-icon"></div>
				</a>
				<router-link tag="div" class="sidenav-item" :to="{ path: '/pages', name: 'pages'}">
					<font-awesome-icon :icon="['far', 'file-alt']"></font-awesome-icon>
					<p>Pages</p>
				</router-link>
				<router-link tag="div" class="sidenav-item" :to="{ path: '/snippets', name: 'snippets'}">
					<font-awesome-icon :icon="['far', 'file-code']"></font-awesome-icon>
					<p>Snippets</p>
				</router-link>
				<router-link tag="div" class="sidenav-item" :to="{ path: '/configuration', name: 'configuration'}">
					<font-awesome-icon :icon="['fas', 'cog']"></font-awesome-icon>
					<p>Config</p>
				</router-link>
				<a
				:href="this.$store._vm.DOMAIN_URL + '/users/' + this.$store._vm.USER + '/' + this.$store._vm.PROJECT + '/published/uploads'"
				target="_blank"
				class="external-item">
					<div class="sidenav-item">
						<font-awesome-icon :icon="['fas','file-upload']"></font-awesome-icon>
						<p>Uploads</p>
					</div>
				</a>
				<!-- <router-link tag="div" class="sidenav-item" :to="{ path: '/email-templates', name: 'email-templates'}">
					<font-awesome-icon :icon="['fas', 'envelope-open-text']"></font-awesome-icon>
					<p>Email templates</p>
				</router-link> -->
			</div>
			<div class="sidenav-right">
				<a href="#" class="" @click.prevent="exp()">
					<div class="sidenav-item">
						<font-awesome-icon :icon="['fas', 'upload']"></font-awesome-icon>
						<p>Export</p>
					</div>
				</a>
				<a href="#" class="" @click.prevent="imp()">
					<div class="sidenav-item">
						<font-awesome-icon :icon="['fas', 'download']"></font-awesome-icon>
						<p>Import</p>
					</div>
				</a>
				<div class="sidenav-item" @click="togglesettings()" ref="settings">
					<font-awesome-icon :icon="['fas', 'sliders-h']"></font-awesome-icon>
					<p>Settings</p>
				</div>
				<div class="sidenav-item">
					<font-awesome-icon :icon="['fas', 'rocket']"></font-awesome-icon>
					<p><a target="_blank" href="https://developers.dcsplus.net/users/demo/docs/published/api.html">REST Api</a></p>
				</div>
				<div class="sidenav-item">
					<font-awesome-icon :icon="['fas', 'book']"></font-awesome-icon>
					<p><a target="_blank" href="https://developers.dcsplus.net/users/demo/docs/published/index.html">Docs</a></p>
				</div>
				<transition name="fade" mode="out-in">
					<div v-if="active" @click.self="closemodal($event)" class="full-screen-wrapper">
						<drop-down-modal :width="329" :reference="$refs" :active="editorMode">
						</drop-down-modal>
					</div>
				</transition>
				<template v-if="isLogedIn">
					<router-link tag="div" class="sidenav-item" @click.native="logout" :to="{ path: '/login', name: 'login'}">
						<font-awesome-icon :icon="['fas', 'sign-out-alt']"></font-awesome-icon>
						<p>Logout</p>
					</router-link>
				</template>
				<template v-else>
					<router-link tag="div" class="sidenav-item" :to="{ path: '/login', name: 'login'}">
						<font-awesome-icon :icon="['far', 'user-circle']"></font-awesome-icon>
						<p>Sign In</p>
					</router-link>
				</template>

			</div>
		</div>
		<div class="main-container">
			<router-view></router-view>
			<transition name="fade" mode="out-in">
				<div v-if="modalOpened" @click.self="closemodal($event)" class="full-screen-wrapper">
					<Exporter v-if="exporting"></Exporter>
					<Importer v-if="importing"></Importer>
				</div>
			</transition>
		</div>
	</div>
</template>
<script>
// import { throttle, debounce } from 'throttle-debounce'
import { throttle } from 'throttle-debounce'
import DropDownModal from '../components/DropDownModal'
import Exporter from '../components/Export'
import Importer from '../components/Import'
export default {
	components: {
		DropDownModal,
		Exporter,
		Importer
	},
	data () {
		return {
			active: false,
			exporting: false,
			importing: false,
			refObj: {}
		}
	},
	methods: {
		modalResponse (val) {
			if (val.resp === true) {
				this.$store.dispatch('Pages/deletePage', val.note)
				this.activeModal = false
			} else {
				this.activeModal = false
			}
		},
		logout () {
			this.$store.dispatch('logout')
		},
		addToast () {
			this.$store.commit('Toast/_add', Math.random())
		},
		holdThis (toast) {
			if (toast.intervalID) {
				window.clearInterval(toast.intervalID)
				toast.intervalID = null
			} else {
				this.removeThis(toast)
			}
		},
		removeThis (toast) {
			this.$store.commit('Toast/_remove', toast)
		},
		togglesettings () {
			this.active = !this.active
		},
		closemodal (e) {
			e.stopPropagation()
			this.active = false
			// this.activeModal = false
			this.$store.dispatch('closeModal')
		},
		exp() {
			this.importing = false
			this.exporting = true
			this.$store.dispatch('openModal')
		},
		imp() {
			this.exporting = false
			this.importing = true
			this.$store.dispatch('openModal')
		},
		watchEvents: throttle(30000, function () {
			// reset keepAlive timer if activity was detected in 30 seconds
			this.$store.dispatch('resetKeepAliveClientSideTimer')
		})
	},
	mounted () {
	},
	computed: {
		toasts () {
			return this.$store.getters['Toast/_toasts']
		},
		isLogedIn () {
			return this.$store.getters.isLoggedIn
		},
		editorMode () {
			return this.$store.getters.getMode
		},
		modalOpened () {
			return this.$store.getters.modalOpened
		},
		appLoading () {
			return this.$store.getters.appLoading
		}
	},
	created () {
		this.$store.dispatch('Pages/fetchAll')
		this.$store.dispatch('Snippets/fetchSnippets')
		this.$store.dispatch('Snippets/fetchWidgets')
		this.$store.dispatch('Snippets/fetchDataSource')
	}
}
</script>
<style lang="scss">
@import '@/styles/modules/_dashboard.scss';
#main.isloading {
	&:before {
		content: "";
		display: block;
		position: absolute;
		width: 100%;
		height: 100%;
		background: #000000b3;
		z-index: 100;
	}
	// &:after {
	// 	content: "\2600";
	// 	display: inline-block;
	// 	position: absolute;
	// 	font-family: monospace;
	// 	font-size: 100px;
	// 	color: #3a3a3a;
	// 	z-index: 101;
	// 	width: 83px;
	// 	height: 83px;
	// 	text-align: center;
	// 	vertical-align: middle;
	// 	left: 50%;
	// 	top: 43%;
	// 	line-height: 88px;
	// 	transition: transform;
	// 	transform-origin: center;
	// 	animation:rotate infinite forwards 3s;
	// 	animation-timing-function: linear;
	// }
	// @keyframes rotate {
	// 	0% {
	// 		transform: rotate(0deg);
	// 	}
	// 	100% {
	// 		transform: rotate(360deg);
	// 	}
	// }
}
</style>
